import React from 'react';
import {
  defineMessages,
  FormattedMessage,
  useIntl,
  type MessageValue,
  type NoMessageValues,
} from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { Button, theme } from '@sg/garnish';

import { type ScanToPayPalette } from '../../utils';

export const ScanToPayPointsCta = (props: ScanToPayPointsCtaProps) => {
  const { points, palette, onPress } = props;

  const { formatNumber, formatMessage } = useIntl();
  const a11yLabel = formatMessage(messages.a11yLabel);

  const icon = palette === 'cream' ? 'IconSgRewardWhiteFill' : 'IconSgRewardKaleFill';

  return (
    <View style={styles.container}>
      <Button
        palette={palette === 'cream' ? 'forest' : 'light'}
        size="large"
        accessibilityRole="button"
        accessibilityLabel={a11yLabel}
        leftIcon={icon}
        style={styles.cta}
        onPress={onPress}
      >
        <FormattedMessage {...messages.cta} values={{ points: formatNumber(points) }} />
      </Button>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages<{
  readonly cta: { readonly points: MessageValue };
  readonly a11yLabel: NoMessageValues;
}>({
  cta: {
    defaultMessage: '{points} points',
    description: 'Scan To Pay | Points CTA',
  },
  a11yLabel: {
    defaultMessage: 'Open loyalty info',
    description: 'Scan To Pay | Points CTA | Accessibility Label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  cta: {
    paddingHorizontal: theme.spacing['2'],
    alignItems: 'center',
    justifyContent: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayPointsCtaProps = {
  points: number;
  palette: ScanToPayPalette;
  onPress: () => void;
};
